import {
  CREATE_NEW_CADERNO_ENCARGOS,
  GET_CADERNOS_ENCARGOS,
  SET_CADERNOS_ENCARGOS,
  SET_NEW_CADERNO_ENCARGOS,
  ERROR_CADERNO_ENCARGOS,
  GET_CVS,
  SET_CVS,
  GET_SPECIFIC_CV,
  SET_SPECIFIC_CV,
  CREATE_NEW_CV,
  SET_NEW_CV,
  ERROR_CV,
  SET_SAVE_CV_MGR_LOADING,
  SET_GENERATE_CV_PROMPT,
  UPDATED_CV,
  SET_UPDATED_CV,
  SET_CREATED_CV,
  SET_CREATED_CADERNO_ENCARGO,
  GET_SPECIFIC_ENCARGO,
  SET_SPECIFIC_ENCARGO,
  UPDATED_ENCARGO,
  SET_UPDATED_ENCARGO,
  GET_PROFILES_BY_ENCARGO,
  SET_PROFILES_BY_ENCARGO,
} from "./actionTypes";

const initialState = {
  cadernosEncargosAllList: [],
  isLoadingCadernosEncargos: false,
  cadernoEncargosData: {},
  isLoadingCadernoEncargosData: false,
  errorCadernoEncargosShow: false,
  errorCadernoEncargosMessage: "",
  cvAllList: [],
  isLoadingCvs: false,
  cvData: {},
  isLoadingCvData: false,
  errorCVShow: false,
  errorCVMessage: "",
  isLoadingSaveCvMgrConfiguration: false,
  generateCVPromptResult: "",
  cvDataSelected: {},
  isLoadingSpecificCv: false,
  updatedCv: false,
  updatedCvMsg: "",
  encargoDataSelected: {},
  isLoadingSpecificEncargo: false,
  updatedEncargo: false,
  updatedEncargoMsg: "",
  createdCv: false,
  createdCvMsg: "",
  createEncargo: false,
  createEncargoMsg: "",
  isLoadingProfilesByEncargo: false,
  profilesByEncargo: {},
};

export function cvManagementReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CADERNOS_ENCARGOS:
      return { ...state, isLoadingCadernosEncargos: true };
    case CREATE_NEW_CADERNO_ENCARGOS:
      return { ...state, isLoadingCadernoEncargosData: true };
    case SET_NEW_CADERNO_ENCARGOS:
      return {
        ...state,
        isLoadingCadernoEncargosData: false,
        cadernoEncargosData: action.cadernoEncargosData,
      };
    case SET_CADERNOS_ENCARGOS:
      return {
        ...state,
        isLoadingCadernosEncargos: false,
        cadernosEncargosAllList: action.cadernosEncargosAllList,
      };
    case GET_SPECIFIC_ENCARGO:
      return { ...state, isLoadingSpecificEncargo: true };
    case SET_SPECIFIC_ENCARGO:
      return {
        ...state,
        isLoadingSpecificEncargo: false,
        encargoDataSelected: action.encargo,
      };
    case UPDATED_ENCARGO:
      return {
        ...state,
        isLoadingSpecificEncargo: true,
      };
    case SET_UPDATED_ENCARGO:
      return {
        ...state,
        isLoadingSpecificEncargo: false,
        updatedEncargo: action.show,
        updatedEncargoMsg: action.msg,
      };

    case GET_CVS:
      return { ...state, isLoadingCvs: true };
    case SET_CVS:
      return {
        ...state,
        isLoadingCvs: false,
        cvAllList: action.cvAllList,
      };
    case GET_SPECIFIC_CV:
      return { ...state, isLoadingSpecificCv: true };
    case SET_SPECIFIC_CV:
      return {
        ...state,
        isLoadingSpecificCv: false,
        cvDataSelected: action.cv,
      };
    case UPDATED_CV:
      return {
        ...state,
        isLoadingSpecificCv: true,
      };
    case SET_UPDATED_CV:
      return {
        ...state,
        isLoadingSpecificCv: false,
        updatedCv: action.show,
        updatedCvMsg: action.msg,
      };
    case SET_CREATED_CV:
      return {
        ...state,
        createdCv: action.show,
        createdCvMsg: action.msg,
      };

    case SET_CREATED_CADERNO_ENCARGO:
      return {
        ...state,
        createEncargo: action.show,
        createEncargoMsg: action.msg,
      };
    case CREATE_NEW_CV:
      return { ...state, isLoadingCvData: true };
    case SET_NEW_CV:
      return {
        ...state,
        isLoadingCvData: false,
        cvData: action.cvData,
      };
    case ERROR_CV:
      return {
        ...state,
        errorCVShow: action.error,
        errorCVMessage: action.message,
      };
    case ERROR_CADERNO_ENCARGOS:
      return {
        ...state,
        errorCadernoEncargosShow: action.error,
        errorCadernoEncargosMessage: action.message,
      };

    case SET_SAVE_CV_MGR_LOADING:
      return {
        ...state,
        isLoadingSaveCvMgrConfiguration: action.loading,
      };
    case SET_GENERATE_CV_PROMPT:
      return {
        ...state,
        generateCVPromptResult: action.cvPrompt,
        isLoadingSaveCvMgrConfiguration: false,
      };
    case GET_PROFILES_BY_ENCARGO:
      return { ...state, isLoadingProfilesByEncargo: true };
    case SET_PROFILES_BY_ENCARGO:
      return {
        ...state,
        isLoadingProfilesByEncargo: false,
        profilesByEncargo: action.profiles,
      };

    default:
      return state;
  }
}
